<template>
  <div
    class="code-wrapper-child"
    :class="{
      shouldBlur: isGuestMode && !isPreservedVulnerability,
    }"
  >
    <div class="info">
      <div class="vulnerability_level">
        Found in file
        <b class="file-name">{{ block.file }}</b>
      </div>
    </div>
    <div class="code">
      <div
        v-if="block.lines.length > 0"
        class="vulnerability__line"
        :class="
          colorOfVulnerabilityForLine(
            vulnerability['vulnerability-category.severity'] || vulnerability['severity']
          )
        "
      />
      <table class="block vulnerability__code-wrapper-table">
        <tbody>
          <tr
            v-for="(line, lineIndex) in block.lines"
            :key="lineIndex"
            :class="getHighlightedLineClass(line, vulnerability['format'])"
          >
            <td class="vulnerability__code-line-number">
              {{ line.line_number }}
            </td>
            <td>
              <pre
                v-highlightjs="minAllowedSpacesBeforeCode + line.content.substring(block.minSpaces)"
                class="hljs"
              ><code
                    :class="getHighlightLanguageBySourceType(block.source_type)"></code></pre>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VulnCodeBlockItem',
  props: {
    vulnerability: {
      type: Object,
      required: true,
    },
    block: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      minAllowedSpacesBeforeCode: '   ',
    };
  },
  computed: {
    isPreservedVulnerability() {
      if (!this.vulnerability || !this.$route.params.vulnerabilityId) {
        return false;
      }

      return this.$route.params.vulnerabilityId === this.vulnerability.id;
    },

    isGuestMode() {
      return this.$route.name === 'GuestScanInfo';
    },
  },
  methods: {
    getHighlightedLineClass(line, format) {
      if (format === 'fixed' && line.is_matched) {
        return format === 'fixed' && 'highlight_green';
      }

      if (format === 'created' && line.is_matched) {
        return format === 'created' && 'highlight_red';
      }

      return line.is_matched ? 'highlight' : '';
    },
    colorOfVulnerabilityForLine(severity) {
      if (severity === 'low') {
        return 'line-green';
      }

      if (severity === 'medium') {
        return 'line-yellow';
      }

      if (severity === 'high') {
        return 'line-red';
      }
    },
    getHighlightLanguageBySourceType(sourceType) {
      return ['xml', 'java', 'swift'].find((lang) => lang === sourceType) || 'plaintext';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/fonts';
@import '../../assets/css/variables';
@import url('https://fonts.googleapis.com/css2?family=Inconsolata&display=swap');

.info {
  display: flex;
  width: fit-content;
}

.file-name {
  @include Aspekta-font(500, 14px, 26px, #021631);
  word-break: break-word;
}

.code-wrapper-child {
  margin-top: 20px;
  overflow: hidden;

  &.shouldBlur {
    filter: blur(4px);
    pointer-events: none;
    user-select: none;
  }
}

.code-wrapper-child tbody tr td {
  padding: 0 !important;
}

.vulnerability__code-wrapper-table {
  overflow: hidden;
}

.code {
  margin-top: 16px;
  display: flex;
  overflow: auto;
  position: relative;
  font-family: 'Inconsolata', monospace;

  &::-webkit-scrollbar {
    display: none;
  }
}

.vulnerability__line {
  display: block;
  border: 2px solid transparent;
  background-color: lightgrey;
}

.line-green {
  background-color: $low-vulnerability-color;
}

.line-yellow {
  background-color: $medium-vulnerability-color;
}

.line-red {
  background-color: $high-vulnerability-color;
}

body td.vulnerability__code-line-number {
  padding-left: 40px;
  font-variant-numeric: tabular-nums;
  font-family: 'Inconsolata', monospace;
  font-size: 14px;
  line-height: 26px;
}

.vulnerability_level {
  @include Aspekta-font(400, 14px, 20px, #5c6a7a);
  letter-spacing: 0.02em;
  width: 100%;
}

.code-wrapper-child tbody tr td:first-child {
  padding-left: 40px !important;
  padding-right: 15px !important;
  width: 20px;
}

table {
  border-collapse: collapse;
  border: 0;
}

table.block {
  width: 100% !important;
  background-color: #f8fafc !important;
  border: 0;
  transition: 0.3s;
}

.hljs {
  background-color: transparent !important;
}

pre {
  margin: 0;
}

.hljs {
  background-color: inherit;
  border-style: none;
  padding: 0;
  height: 100%;
  color: #021631;
}

code.hljs {
  text-shadow: none;
}

.highlight td:nth-child(1) {
  background-color: #feeae7;
}

.highlight td:nth-child(2) {
  background-color: #feeae7;
}
.hljs {
  background-color: transparent !important;
}

.highlight_red {
  background-color: rgba(254, 234, 231, 1);
}

.highlight_green {
  background-color: rgba(76, 224, 116, 0.1);
}
</style>
